import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';

import { Sizes, Typography } from '@ratehub/base-ui';
import { DownPaymentCalculator } from '@ratehub/calculators';

import PAGE_TEMPLATES from '../definitions/PageTemplates';


function MortgageDownPaymentCalculator({ disclaimer, ...otherProps }) {
    return (
        <Container>
            <DownPaymentCalculator
                className="calculator"
                {...otherProps}
            />

            <If condition={disclaimer}>
                <p className={
                    classNames(
                        Typography.CLASSES.TEXT_XS,
                        'disclaimer',
                    )}
                >
                    {disclaimer}
                </p>
            </If>
        </Container>
    );
}

MortgageDownPaymentCalculator.propTypes = {
    disclaimer: PropTypes.string,
};

MortgageDownPaymentCalculator.defaultProps = {
    disclaimer: undefined,
};

const CONTAINER_MAX_WIDTH = '70rem';

const Container = styled.section`
    padding: ${Sizes.SPACING.HALF} 0;
    max-width: ${CONTAINER_MAX_WIDTH};
    margin: 0 auto;

    > .disclaimer {
        margin: 0;
        text-align: center;

        padding-top: ${Sizes.SPACING.HALF};
    }
`;

MortgageDownPaymentCalculator.blockKey = 'rh/mortgage-downpayment-calculator';
MortgageDownPaymentCalculator.requiresLayoutRow = true;
MortgageDownPaymentCalculator.hasHeading = false;
MortgageDownPaymentCalculator.supportedPageTypes = [ PAGE_TEMPLATES.calculatorsMtg ];

export default MortgageDownPaymentCalculator;
